import axios from "axios";
import { apiVariable } from "./apiVariable";

export interface AiSplitItemDto {
  complaint: string | null;
  finalCost: number | null;
  incidentType: string | null;
  completedDate: string;
  reviewIssues: string[];
}

export interface AiSplitProposalDto {
  repairId: string;
  incidentId: string;
  repairAmount: number;
  invoiceTotal: number | null;
  parentAmount: number;
  childSplitsTotal: number;
  proposedTotal: number;
  requiresSplit: boolean;
  canConfirm: boolean;
  message: string | null;
  reviewIssues: string[];
  parent: AiSplitItemDto | null;
  splits: AiSplitItemDto[];
}

export interface ConfirmAiSplitsDto {
  repairId: string;
  expectedRepairAmount: number;
  parentAmount: number | null;
  parentIncidentType: string | null;
  splits: Array<{
    complaint: string;
    finalCost: number;
    incidentType: string;
    completedDate: string;
  }>;
}

const headers = (token?: string | null) => ({
  Authorization: `Bearer ${token}`,
});

export const generateAiSplitProposal = async (
  incidentId: string,
  repairId: string,
  token?: string | null,
): Promise<AiSplitProposalDto> => {
  const { data } = await axios.post(
    `${apiVariable}/incident/${incidentId}/repair/${repairId}/ai-split-proposal`,
    undefined,
    { headers: headers(token) },
  );

  return data;
};

export const confirmAiSplits = async (
  incidentId: string,
  confirmation: ConfirmAiSplitsDto,
  token?: string | null,
) => {
  const { data } = await axios.post(
    `${apiVariable}/incident/${incidentId}/confirm-ai-splits`,
    confirmation,
    { headers: headers(token) },
  );
  return data;
};
